export const styles = {
  inputColorStyle: {
    color: '#A1A1A1',
  },
  closeIconStyle: {
    color: '#A1A1A1',
    fontSize: 20,
    marginTop: "4px",
  },
  closeButtonStyle: {
    cursor: 'pointer',
  },
  timePickerInput: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
color: '#A1A1A1',
    input: { color: '#A1A1A1',
    }
                            },
  },
  timePickerMAIN: { width: { xs: "100%", sm: "50%" }, pr: { sm: 1, md: 2 }, mb: { sm: 2, md: 1 }, mt: { sm: 2, md: 1 } },
timePickerBox: { display: 'flex', alignItems: 'center' }
}